import React, { FC, memo } from 'react'
import { Tabs } from 'antd'
import { useIntl } from 'react-intl'

import RegistryProblems from './RegistryProblems'
import LivestreamTroubleShooting from './LivestreamTroubleShooting'
import GeneralProblems from './GeneralProblems'
import { LandingPageImages } from '../../../utils/links'
import { Menu, Dropdown, Button } from 'antd'

const { TabPane } = Tabs

type FaqProps = { 
    data: any
 }
const FAQ: FC<FaqProps> = ({data}) => {
    const intl = useIntl()

    return (
        <div className="landing-page-faq-background" id="faq" style={{ backgroundImage: `url(${data[0].attributes.landing_config.img_bg2})`}}>
            <div className="landing-page-faq-wrap">
                {/* <h1 className="page-title">{intl.formatMessage({ id: 'landingPage.nav_faq' })}</h1> */}
                <div className="landing-page-title">
                    {data[0].attributes.landing_config &&
                        <img className="landing-page-title-pc" src={data[0].attributes.landing_config.img_faq} alt="" />
                    }

                    {data[0].attributes.landing_config &&
                        <img className="landing-page-title-mo" src={data[0].attributes.landing_config.img_faq_mo} alt="" />
                    }
                </div>
                <Tabs
                    defaultActiveKey="1"
                    size="small"
                    animated={{ inkBar: false, tabPane: false }}
                    tabBarStyle={{
                        color: '#222',
                        fontSize: '10px',
                    }}
                    style={{ 
                        '--ink-bar-color': `${data[0].attributes.landing_config.priminary_color}`,
                        '--ink-bar-color-100': `${data[0].attributes.landing_config.sub_color}` ,
                        '--ink-bar-bg-url':`url(${data[0].attributes.landing_config.img_bg2})`
                    } as React.CSSProperties}
                                        
                >
                    <TabPane tab={intl.formatMessage({ id: 'landingPage.faq_category1' })} key="1">
                        <RegistryProblems />
                    </TabPane>
                    <TabPane tab={intl.formatMessage({ id: 'landingPage.faq_category2' })} key="2">
                        <GeneralProblems />
                    </TabPane>
                    <TabPane tab={intl.formatMessage({ id: 'landingPage.faq_category3' })} key="3">
                        <LivestreamTroubleShooting />
                    </TabPane>
                </Tabs>
            </div>
        </div>
    )
}

export default memo(FAQ)
